'use strict';

const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'vendorId', 'couponId', '_gl', '_ga', 'gclid', 'gclsrc', 'msclkid'],
    domains = ['intia.fr', 'infast.fr'];

// SVG
(function () {
    svg4everybody({
        validate: function validate(src, svg, use) {
            return src.substr(0, 1) !== '#';
        }
    });
})();

var faqItems = document.querySelectorAll('.intia-block-question-item');

faqItems.forEach(function (item) {
    var title = item.querySelector('.intia-block-question-item__title');

    title.addEventListener('click', function () {
        if (item.classList.contains('open')) {
            item.classList.remove('open');
        } else {
            item.classList.add('open');
        }
    });
});

// Header
(function ($) {
    var $header = $('.js-header').addClass('is-fixed'),
        $navigation = $header.find('.js-header-navigation'),
        $toggle = $header.find('.js-header-toggle'),
        $window = $(window),
        $html = $('html');

    $toggle.on('click', function (e) {
        e.preventDefault();

        $header.toggleClass('is-active');
        var active = $header.hasClass('is-active');
        $navigation.attr('aria-hidden', !active);
        if (active) {
            removeButtonSub();
            subMenu();
        } else {
            removeButtonSub();
        }
        $html[active ? 'addClass' : 'removeClass']('is-header-active');
    });

    function checkScroll() {
        $header[$window.scrollTop() > 0 ? 'addClass' : 'removeClass']('is-scrolled');
        $header[$window.scrollTop() > $window.height() / 4 ? 'addClass' : 'removeClass']('is-scrolled-more');
    }

    checkScroll();
    $window.on('scroll', checkScroll);

    function subMenu() {
        var $nav = $('.c-header__navigation.js-header-navigation');
        var $itemMenuSub = $nav.find('.menu-item-has-children');
        var $itemHasSub = $nav.find('a[href="#"], a:not([href])');
        $itemMenuSub.each(function (index) {
            $(this).children(":first").after('<button class=\'showsub\'></button>');
        });

        $itemHasSub.each(function (index) {
            $(this).click(function () {
                $(this).parent().find(".sub-menu").toggleClass("is-active");
                $(this).next(".showsub").toggleClass("active");
            });
        });

        var $buttonShow = $('.showsub');
        $buttonShow.click(function () {
            $(this).next(".sub-menu").toggleClass("is-active");
            $(this).toggleClass("active");
        });
    }

    function removeButtonSub() {
        var $buttonShow = $('.showsub');
        $buttonShow.remove();
    }
})(jQuery);

// Prices
(function ($) {
    var $choices = $('.js-prices-choice');
    var $textInfast = $('.js-prices-text--infast');
    var $textInfurious = $('.js-prices-text--infurious');
    var $priceInfast = $('.js-prices-name--infast');
    var $priceInfurious = $('.js-prices-name--infurious');

    $choices.on('click', function (e) {
        e.preventDefault();
        var $choice = $(this);
        var $duration = $choice.data('duration');
        console.log('DURATION', $duration);

        $choices.not($choice.addClass('is-active')).removeClass('is-active');

        switch ($duration) {
            case 1:
                $priceInfast.text('29€ HT');
                $textInfast.text('Sans engagement');
                $priceInfurious.text('49€ HT');
                $textInfurious.text('Sans engagement');
                break;
            case 12:
                $priceInfast.text('290€ HT');
                $textInfast.text('Paiement comptant');
                $priceInfurious.text('490€ HT');
                $textInfurious.text('Paiement comptant');
                break;
            case 24:
                $priceInfast.text('522€ HT');
                $textInfast.text('Paiement comptant');
                $priceInfurious.text('882€ HT');
                $textInfurious.text('Paiement comptant');
                break;
        }
    });
})(jQuery);

// Toggle switch between annual/monthly plans
(function ($) {
    var toggle = $('.toggle_plan_duration_annual');

    if (!toggle.length) {
        return;
    }

    // Initial state: annual is shown by default (unchecked)
    $('.pricing-plan__price-container-annual').show();
    $('.pricing-plan__price-container-monthly').hide();

    toggle.on('change', function (e) {
        console.log('change');
        if ($(this).is(':checked')) {
            // Annual selected
            $('.pricing-plan__price-container-monthly').hide();
            $('.pricing-plan__price-container-annual').show();
        } else {
            // Monthly selected
            $('.pricing-plan__price-container-annual').hide();
            $('.pricing-plan__price-container-monthly').show();
        }
    });

    $('.force-check').on('click', function (e) {
        e.preventDefault();
        toggle.prop('checked', true).trigger('change');
    })
})(jQuery);

// Lightbox
(function ($) {
    // If this selector is updated, please update it in obfuscate_link_in_content() (www/app/themes/intia/lib/obfuscate.php)
    $('a[rel="lightbox"], a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function () {
        var $anchor = $(this),
            type = $anchor.data('type') || 'image';

        if ($anchor.is('[download]')) return;

        $anchor.magnificPopup({
            type: type,
            overflowY: 'scroll'
        });
    });

    $.extend(true, $.magnificPopup.defaults, {
        tClose: '&times;',
        tLoading: '…',
        gallery: {
            tPrev: '‹',
            tNext: '›',
            tCounter: '%curr%/%total%'
        },
        image: {
            tError: '<a href="%url%">L’image</a> n’a pas pu être chargée.'
        },
        iframe: {
            tError: '<a href="%url%">Le contenu</a> n’a pas pu être chargé.'
        }
    });
})(jQuery);

(function ($) {
    $('a.js-sharer').on('click', function (e) {
        e.preventDefault();
        window.open($(this).attr('href'), 'sharer', 'toolbar=0,status=0,width=640,height=480,top=' + (screen.height - 480) / 2 + ',left=' + (screen.width - 640) / 2);
    });
})(jQuery);

// Object fit
(function ($) {
    if (!!(window.CSS && window.CSS.supports || window.supportsCSS || false) && CSS.supports('object-fit', 'cover')) return;
    $('img.js-object-fit').each(function () {
        var $img = $(this);
        $img.replaceWith('<div class="' + $img.attr('class') + '" style="background-image: url(' + $img.attr('src') + ');"/>');
    });
})(jQuery);

// UTM
(function ($) {
    if (location.search === '') return;

    // Convert query string to object
    var params = JSON.parse('{"' + decodeURI(location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

    // Filter UTM params
    var filteredParams = Object.keys(params).filter(function (key) {
        return utmParams.includes(key);
    }).reduce(function (obj, key) {
        obj[key] = params[key];
        return obj;
    }, {});

    // Convert filtered params to query string
    var queryString = $.param(filteredParams);

    // Append filtered query string to links
    $('a[href^="http"]').each(function () {
        var _this = this;

        var $link = $(this),
            href = $link.attr('href');

        // Filter only internal links
        if (!domains.filter(function (domain) {
            return _this.hostname.match(domain);
        }).length) return;

        $link.attr('href', href + (href.match(/\?/) ? '&' : '?') + queryString);
    });
})(jQuery);

// FAQ Collapsible
(function ($) {

    var $faqs = $(".c-container__faq");
    var $toggleFAQ = $faqs.find('.c-faq__question');
    $toggleFAQ.on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-active');
        var content = $(this).parent().find('.c-faq__response');
        if (content[0].style.maxHeight) {
            content[0].style.maxHeight = null;
            content[0].style.marginTop = null;
            content[0].style.paddingTop = null;
            content[0].style.paddingBottom = null;
            content[0].style.borderTop = null;
        } else {
            content[0].style.marginTop = "1rem";
            content[0].style.paddingTop = "1.5rem";
            content[0].style.paddingBottom = "1rem";
            content[0].style.maxHeight = content[0].scrollHeight + "px";
            content[0].style.borderTop = "1px solid #F1F1F1";
        }
    });
})(jQuery);

(function ($) {

    var newsletterBlock = $(".newsletter-form");
    if (newsletterBlock.length < 1) {
        return;
    }

    newsletterBlock.on('submit', function (e) {
        var _this2 = this;

        e.preventDefault();

        $('.intia-block-newsletter__error').hide();

        var data = {
            action: 'subscribe_newsletter',
            nonce: $(this).find('input[name=nonce]').val(),
            email: $(this).find('input[name=email]').val()
        };

        fetch($(this).attr('action'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
            },
            body: new URLSearchParams(data)
        }).then(function (response) {
            return response.json();
        }).then(function (body) {
            // Error
            if (!body.success) {
                $('.intia-block-newsletter__error').text(body.data).show();
                return;
            }

            // Success
            $(_this2).hide();
            $('.intia-block-newsletter__error').hide();
            $('.intia-block-newsletter__success').show();
        });
    });
})(jQuery);

(function ($) {
    AOS.init();
})(jQuery);

// Create Summary

if (document.getElementById('summarywrapper')) {
    var debounce = function debounce(callback, delay) {
        var timer = void 0;
        return function () {
            var args = arguments;
            var context = this;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, delay);
        };
    };

    // Scroll Spy

    var ratio = .4;
    var spies = document.querySelectorAll('[data-spy]');
    var observer = null;

    var activate = function activate(elem) {
        var id = elem.getAttribute('id');
        var anchor = document.querySelector('a[href="#' + id + '"]');
        if (anchor === null) {
            return null;
        }
        anchor.parentElement.parentElement.querySelectorAll('.active').forEach(function (node) {
            return node.classList.remove('active');
        });
        anchor.parentElement.classList.add('active');
    };

    var activateLink = function activateLink(id) {
        var anchor = document.querySelector('a[href="#' + id + '"]');
        if (anchor === null) {
            return null;
        }
        anchor.parentElement.parentElement.querySelectorAll('.active').forEach(function (node) {
            return node.classList.remove('active');
        });
        anchor.parentElement.classList.add('active');
    };

    var callback = function callback(entries, observer) {
        entries.forEach(function (entry) {
            if (entry.intersectionRatio > 0) {
                activate(entry.target);
            }
        });
    };

    var observe = function observe(elems) {
        if (observer !== null) {
            elems.forEach(function (elem) {
                return observer.unobserve(elem);
            });
        }
        var y = Math.round(window.innerHeight * ratio);
        observer = new IntersectionObserver(callback, {
            rootMargin: '-' + (window.innerHeight - y - 1) + 'px 0px -' + y + 'px 0px'
        });
        spies.forEach(function (elem) {
            return observer.observe(elem);
        });
    };

    if (spies.length > 0) {
        observe(spies);
        var windowH = window.innerHeight;
        window.addEventListener('resize', debounce(function () {
            if (window.innerHeight !== windowH) {
                observe(spies);
                windowH = window.innerHeight;
            }
        }, 500));
    }

    // Modal links (#modal-XXX) are excluded: they must navigate so :target applies
    document.querySelectorAll('a[href^="#"]:not([data-obfuscated-url]):not([href^="#modal-"])').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            var id = this.getAttribute('href').split('#')[1];
            if (!id) {
                return;
            }
            var element = document.getElementById(id);
            if (!element) {
                return;
            }
            e.preventDefault();
            activateLink(id);
            var yOffset = -150;
            var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        });
    });

    const select = document.getElementById('summary-select')

    select.addEventListener("change", function (event) {
        var id = event.target.value.split('#')[1];
        var yOffset = -80;
        var element = document.getElementById(id);
        var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    });
}

(function ($) {
    $('.js-pricing-show-more').click(function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).find('span').text('Voir le détail de l\'offre');
            $(this).siblings('.pricing-plan__features').removeClass('open');
        } else {
            $(this).addClass('open');
            $(this).find('span').text('Voir moins');
            $(this).siblings('.pricing-plan__features').addClass('open');
        }
    });
})(jQuery);

// Lottie loading
document.addEventListener("DOMContentLoaded", function () {
    var lotties = document.querySelectorAll('.intia-block-lottie');

    lotties.forEach(function (el) {
        var animation = lottie.loadAnimation({
            container: el,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: "/animations/" + el.dataset.lottie
        });
    });
});

// Marketing bar closing
function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
}
function readCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
}
document.addEventListener("DOMContentLoaded", function () {
    var closeBtn = document.getElementById('message-bar-close');

    if (!closeBtn) return;

    closeBtn.addEventListener('click', function () {
        console.log('click');

        // Récupère la valeur de l'attribut data-bar
        var dataBar = this.dataset.bar;

        // Cache le parent (ex: la barre marketing)
        if (this.parentElement) {
            this.parentElement.style.display = 'none';
        }

        // Écrit un cookie qui dure 30 jours
        writeCookie('close-marketingbar-' + dataBar, '1', 30);
    });
});

const decodeButton = (event) => {

    const button = event.currentTarget
    const encodedUrl = button.dataset.obfuscatedUrl
    if (!encodedUrl) return

    const obfuscationSalt = window.obfuscationSalt
    let decodedUrl = atob(encodedUrl)
    decodedUrl = decodedUrl.replace(obfuscationSalt, '')

    // Forward analytics query string to the obfuscated link
    if (domains.filter(domain => decodedUrl.match(domain)).length) {
        let queryParams = [];
        location.search.substring(1).split('&').forEach(param => {
            const [key, value] = param.split('=');
            if (utmParams.includes(key)) {
                queryParams.push(`${key}=${value}`);
            }
        })
        decodedUrl = `${decodedUrl}${queryParams.length ? '?' : ''}${queryParams.join('&')}`;
    }

    // Set real href so GA can decorate it with _gl on the upcoming click
    button.href = decodedUrl
    delete button.dataset.obfuscatedUrl
}

document.addEventListener("DOMContentLoaded", function () {
    const obfuscatedButtons = document.querySelectorAll('[data-obfuscated-url]')
    obfuscatedButtons.forEach(button => {
        // Decode on mousedown/touchstart so href is ready when the click fires
        button.addEventListener('mousedown', decodeButton)
        button.addEventListener('touchstart', decodeButton)

        button.addEventListener('click', (e) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'gtm.clickObfuscated',
                'gtm.element': button,
                'gtm.elementUrl': button.href,
                'gtm.linkText': button.innerText,
                'gtm.triggers': '',
            })
        })
    })
})

// Modal: closing on Escape (opening/closing is otherwise pure CSS, see blocks/modal.scss)
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!document.querySelector('.modal:target')) return;

    // Same target as the close links: an anchor that matches nothing, so :target no longer applies
    location.hash = '!';
});
